import { getRequest } from '@/core';
import { customers } from '@/requests';
export default async function getCustomersRequest() {
	try {
		let url = customers.getAllPath();
		return await getRequest(url);
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
